export function toExternalHref(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return '#';
  const candidate = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  try {
    const url = new URL(candidate);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return '#';
    return url.toString();
  } catch {
    return '#';
  }
}
